import { useDispatch } from "react-redux";
import { string } from "yup";

import { updateEntry } from "../../../actions/entry";
import { SelfSubmittingField } from "../forms/selfSubmittingField/SelfSubmittingField";
import { useCallback } from "react";

export const EditSeedForm = ({ entry }) => {
    const dispatch = useDispatch();
    const onSubmit = useCallback(
        (values) =>
            dispatch(
                updateEntry(
                    entry.get("event_division_id"),
                    entry.get("id"),
                    entry.set("seed", values.seed),
                    1,
                ),
            ),
        [entry.get("event_division_id"), entry.get("id")],
    );
    const field = {
        name: "seed",
        type: "number",
        width: 75,
        validation: string().matches(/^\d*$/).nullable(),
        placeholder: entry.get("rank"),
        inputProps: {
            pattern: "[0-9]*",
            maxLength: "10",
            size: 2,
            onClick: (e) => e.stopPropagation(),
        },
    };

    return (
        <SelfSubmittingField
            onSubmit={onSubmit}
            initialValue={entry.get("seed") || ""}
            field={field}
        />
    );
};
